import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import { PermissionRouteGuard } from '@/hooks/usePermissions'
import { Spinner } from '@/components/common/Spinner'

const LiveMapPage = lazy(() => import('@/pages/LiveMap'))

export const Route = createFileRoute('/_authenticated/live-map')({
  component: function LiveMapRoute() {
    return (
      <PermissionRouteGuard resource="live_map" action="read">
        <Suspense fallback={<Spinner />}>
          <LiveMapPage />
        </Suspense>
      </PermissionRouteGuard>
    )
  },
})
